import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzOffer275 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER2_75: Record<
  Exclude<PageIdWoofzOffer275, PageIdWoofzOffer275.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzOffer275.SUBSCRIPTIONS_OFFER2_75]: {
    id: PageIdWoofzOffer275.SUBSCRIPTIONS_OFFER2_75,
    hasHeader: false,
  },
  [PageIdWoofzOffer275.CHAT_UPSELL_OFFER2_75]: {
    id: PageIdWoofzOffer275.CHAT_UPSELL_OFFER2_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer275.UPSELL_OFFER2_75]: {
    id: PageIdWoofzOffer275.UPSELL_OFFER2_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer275.DOWNLOAD_OFFER2_75]: {
    id: PageIdWoofzOffer275.DOWNLOAD_OFFER2_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
